import Dexie from "dexie";


const handwaiDb = new Dexie('HandwaiDB')
handwaiDb.version(2)
    .stores({
        annotations: "unique_id",
        ai: "unique_id",
        lvDocument: "++id",
        advices: "advicesUID",
        aiTrack:"unique_id"
    });
export const db = handwaiDb

export function createHandwaiDB() {

    const db = new Dexie("HandwaiDB");

    (async () => {
        try {
            await db.version(1).stores({
                annotations: "unique_id",
                lvDocument: "++id",
                advices: "advicesUID"
            });
        } catch (error) {
            console.log(error);
        }
    })();

}